import React, { Component } from 'react';
import { Link } from 'react-router-dom';
import en from '../../../../international/translations/en';
class FailedPaymentMessage extends Component {

  trackClick = () => {
    window.analytics.track(
      `Clicked Update Payment Details`,
      { location: 'account-overview',
        user: {
          type: this.props.subscription
        }
      }
    );
  }

  render() {
    const brandName = { sl: 'Surfline', bw: 'Buoyweather', fs: 'FishTrack' };
    const { brand } = this.props;
    return (
      <Link
        className="failed__payment__link"
        to="/account/subscription"
      >
        <div className="failed__payment__message">
          <div className="failed__payment__message__title">
            {en.account.overview.failedPaymentMessage.title.toUpperCase()}
          </div>
          <div className="failed__payment__message__subtitle">
            {en.account.overview.failedPaymentMessage.subtitle(brandName[brand])}
          </div>
        </div>
      </Link>
    );
  }
}

export default FailedPaymentMessage;
